import { Quaternion, Vec3 } from "pixi3d/pixi7";

export class QuaternionExtentions {
    public static fromToRotation(from: Float32Array, to: Float32Array): Quaternion {
        let axis = Vec3.normalize(Vec3.cross(from, to));
        const a = Math.abs(Vec3.squaredMagnitude(axis));
        if (a == 0) {
            // x or y
            if (from[0] !== 0 || from[1] !== 0) {
                axis = Vec3.fromValues(0, 0, 1);
            }
            // z
            else if (from[2] !== 0) {
                axis = Vec3.fromValues(0, 1, 0);
            }
        }

        const angle = Math.acos(Vec3.dot(from, to)) * 57.29578;
        const rad = angle * ((Math.PI * 2) / 360) * 0.5;
        axis = Vec3.scale(axis, Math.sin(rad));
        return new Quaternion(axis[0], axis[1], axis[2], Math.cos(rad));
    }
}
